"use strict";
/**
 * Mint the id grouping every request of one operator click — minted here
 * because the client is the only place the fan-out is a single act
 * (server/order-log/click-id.ts).
 *
 * On the order hot path, so it must NEVER throw: `crypto.randomUUID` is absent
 * in a non-secure context (a dev server reached by LAN IP), and an audit field
 * is not worth failing a real-money order over — hence the cascade below.
 * Every fallback still emits canonical v4 SHAPE, because the server validates
 * the format and the column is `uuid`; a non-uuid would be dropped and the
 * sample button would never arm.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.newClickId = newClickId;
/** Build a v4 uuid string from 16 random bytes. */
function uuidFromBytes(bytes) {
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10x
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"));
    return [
        hex.slice(0, 4).join(""),
        hex.slice(4, 6).join(""),
        hex.slice(6, 8).join(""),
        hex.slice(8, 10).join(""),
        hex.slice(10, 16).join(""),
    ].join("-");
}
/** A uuid identifying this click. Never throws. */
function newClickId() {
    try {
        if (globalThis.crypto?.randomUUID) {
            return globalThis.crypto.randomUUID();
        }
        if (globalThis.crypto?.getRandomValues) {
            return uuidFromBytes(globalThis.crypto.getRandomValues(new Uint8Array(16)));
        }
    }
    catch {
        // Present but throwing (non-secure context) — fall through.
    }
    const bytes = new Uint8Array(16);
    for (let i = 0; i < 16; i++)
        bytes[i] = Math.floor(Math.random() * 256);
    return uuidFromBytes(bytes);
}
